module.exports = __webpack_public_path__ + "static/media/pengajuan.806f5463.svg";